import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { Button, Divider, Grid, Stack, Typography } from '@mui/material';

import { FormRoot, RenderFormField, SideModal } from '@/components';
import { withLoader, WithLoaderProps } from '@/hocs';
import { IPriorityForm } from '@/models';
import { useBuildingInspectionContext } from '@/pages/Tools/BuildingInspection/BuildingInspectionContext';
import { FeesFormFields } from '@/pages/Tools/BuildingInspection/dummy_data/dummy_forms';
import { generateRandomId } from '@/pages/Tools/BuildingInspection/dummy_data/dummy_helper';
import { IFee } from '@/pages/Tools/BuildingInspection/Models';

interface IFeesModalProps extends WithLoaderProps {
  openModal: boolean;
  setOpenModal: (shouldOpen: boolean) => void;
}
const FeesModal = ({ openModal, setOpenModal }: IFeesModalProps) => {
  const { inspectionId } = useParams();
  const { setFees } = useBuildingInspectionContext();
  const methods = useForm<IPriorityForm>({
    defaultValues: {},
    mode: 'all',
  });

  const { handleSubmit, reset } = methods;

  useEffect(() => {
    // If modal is opened, it means user wants to mark the Case as Priority
    if (openModal) {
      reset();
    }
  }, [openModal, reset]);

  const onSubmit = async (values: any) => {
    setFees((prefFee: IFee[]) => [
      ...prefFee,
      {
        _id: generateRandomId(),
        inspection_id: inspectionId,
        datePayed: new Date().toLocaleDateString(),
        ...values,
      },
    ]);
    setOpenModal(false);
  };

  return (
    <SideModal open={openModal} onClose={() => setOpenModal(false)}>
      <Stack
        sx={{
          bgcolor: 'white',
          height: '100%',
          p: 2,
          '.priorityComment textarea': {
            minHeight: 100,
          },
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 1.5 }}>
          Add fee
        </Typography>
        <Divider />

        <FormProvider {...methods}>
          <FormRoot onSubmit={handleSubmit(onSubmit)} sx={{ height: '100%' }}>
            <Grid container spacing={2}>
              {FeesFormFields.map((field) => (
                <Grid key={field?.name} {...field?.grid} item>
                  <RenderFormField {...field} />
                </Grid>
              ))}
            </Grid>
            <Stack
              flexDirection="row"
              justifyContent="flex-end"
              alignSelf="flex-end"
              width="100%"
            >
              <Button
                variant="contained"
                color="inherit"
                size="medium"
                sx={{ mr: 2 }}
                onClick={() => setOpenModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="error"
                size="medium"
                onClick={handleSubmit(onSubmit)}
              >
                Save
              </Button>
            </Stack>
          </FormRoot>
        </FormProvider>
      </Stack>
    </SideModal>
  );
};
export default withLoader(FeesModal);
